module.exports = __webpack_public_path__ + "media/images/banner_video_bg-c253fb6281013734b53fef263ad44937.png";